import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { THIRD_PARTIES } from "Constants/integrationThirdParties";
import { useLocalForage } from "Hooks/useLocalForage";
import {
  selectFeatureObservabilitySuiteIntegrationsEnabled,
  selectFeatureUsageBasedBillingEnabled
} from "Reducers/featureFlags/featureFlags.selectors";
import IntegrationButton from "src/organization/pages/project/settings/integrations/Details/components/IntegrationButton";
import { useAppSelector } from "Store/hooks";

import * as S from "./GettingStarted.styles";
import ObservabilitySuiteList from "./observabilitySuite/ObservabilitySuiteList";

const GettingStarted = () => {
  const observabilitySuiteIntegrationsEnabled = useAppSelector(
    selectFeatureObservabilitySuiteIntegrationsEnabled
  );
  const isUsageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);

  const {
    value: isOpen,
    setValue: setIsOpen,
    isLoading
  } = useLocalForage("integration_getting_started");
  const intl = useIntl();

  if (isLoading || isOpen === false) return null;
  return (
    <S.Wrapper>
      <S.CloseButton onClick={() => setIsOpen(false)} />
      <S.Title tag="h2">
        {intl.formatMessage({
          id: "integrations.getting_started.title",
          defaultMessage: "Select an integration to get started"
        })}
      </S.Title>
      <p>
        {intl.formatMessage({
          id: "integrations.getting_started.intro"
        })}
      </p>
      <S.ListContainer>
        <S.List>
          {THIRD_PARTIES.map(elt => (
            <IntegrationButton key={elt.type} integration={elt} />
          ))}
        </S.List>
        {observabilitySuiteIntegrationsEnabled && (
          <>
            <S.ListDivider />
            <ObservabilitySuiteList />
            {isUsageBilling && (
              <S.CostNotice>
                <Typography.BodyText>
                  {intl.formatMessage({
                    id: "integration.log_forwarding_form_cost_notice"
                  })}
                </Typography.BodyText>
              </S.CostNotice>
            )}
          </>
        )}
      </S.ListContainer>
    </S.Wrapper>
  );
};

export default GettingStarted;
